export default "__VITE_ASSET__ByvZyPEM__"